import React, { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Drawer from '@/components/UI/drawer/Drawer';
import Icon from '@/components/UI/icon/Icon';
import useDrawer from '@/hooks/useDrawer';
import Image from 'next/image';
import SwipeableViews from 'react-swipeable-views';
import { virtualize, bindKeyboard } from 'react-swipeable-views-utils';
import { PicturesRecord } from '../../_types/productItem.types';
import TopSliderGalleryFullHeight from '@/components/houses/housesMobile/topSliderGalleryFullHeight/TopSliderGalleryFullHeight';
import ShareDrawer from '../shareDrawer/ShareDrawer';
import styles from './TopSlider.module.scss';
const VirtualizeSwipeableViews = bindKeyboard(virtualize(SwipeableViews));
interface TopSliderProps {
  images: PicturesRecord[];
  isBookmarked: boolean;
  handleFavorite: any;
  handleBack: () => void;
}
export const TopSlider: FC<TopSliderProps> = ({
  images,
  isBookmarked,
  handleFavorite,
  handleBack
}) => {
  const [current, setCurrent] = React.useState(0);
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const [clickedItemIndex, setClickedItemIndex] = React.useState<number | null>(0);
  const handleMove = index => {
    setCurrent(index);
  };
  const slide = ({
    index,
    key
  }) => {
    return <Box onClick={() => drawerOpen('GALLERY')} className={styles['slide']} component={'figure'} key={key} data-sentry-element="Box" data-sentry-component="slide" data-sentry-source-file="TopSlider.tsx">
        <Image src={images[index]?.hq_thumbnail_path || images[index]?.path} alt={images[index]?.title || ''} title={images[index]?.title} layout="fill" objectFit="cover" onClick={() => {
        setClickedItemIndex(index);
      }} priority={index === 0} loading={index === 0 ? 'eager' : 'lazy'} data-sentry-element="Image" data-sentry-source-file="TopSlider.tsx" />
      </Box>;
  };
  return <>
      <Drawer open={isDrawerOpen('SHARE')} onClose={() => drawerClose()} data-sentry-element="Drawer" data-sentry-source-file="TopSlider.tsx">
        <ShareDrawer handleClose={drawerClose} data-sentry-element="ShareDrawer" data-sentry-source-file="TopSlider.tsx" />
      </Drawer>

      <Drawer open={isDrawerOpen('GALLERY')} onClose={drawerClose} fullHeight data-sentry-element="Drawer" data-sentry-source-file="TopSlider.tsx">
        <TopSliderGalleryFullHeight productImages={images} handleOpenGallery={drawerClose} clickedItemIndex={clickedItemIndex as number} handleFavorite={handleFavorite} isBookmarked={isBookmarked} handleOpenShare={drawerOpen} data-sentry-element="TopSliderGalleryFullHeight" data-sentry-source-file="TopSlider.tsx" />
      </Drawer>

      <Box component="section" id="images" className={styles['top-slider']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
        <Box className={styles['top-slider-navigation']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
          <Box className={styles['close-section']} onClick={handleBack} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
            <Icon name="arrow-right-1" type="highEmphasis" size={22} data-sentry-element="Icon" data-sentry-source-file="TopSlider.tsx" />
          </Box>
          <Box className={styles['share-bookmark-section']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
            <Box className={styles['bookmark-icon']} onClick={handleFavorite} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
              <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} size={20} data-sentry-element="Icon" data-sentry-source-file="TopSlider.tsx" />
            </Box>

            <Box className={styles['bookmark-icon']} onClick={() => drawerOpen('SHARE')} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
              <Icon name={'share'} type="highEmphasis" size={20} data-sentry-element="Icon" data-sentry-source-file="TopSlider.tsx" />
            </Box>
          </Box>
        </Box>

        <Box data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
          <VirtualizeSwipeableViews enableMouseEvents axis="x-reverse" index={current} onChangeIndex={handleMove} slideRenderer={slide} slideCount={images?.length} data-sentry-element="VirtualizeSwipeableViews" data-sentry-source-file="TopSlider.tsx" />
        </Box>

        <Box className={styles['dots-wrapper']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
          <Box className={styles['dots-section']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
            {images?.map((item, index) => <Box className={`${styles['dots-item']} ${current === index ? styles['active-dot'] : ''}`} onClick={() => {
            setCurrent(index);
          }} ref={(ref: HTMLDivElement) => {
            if (current === index) {
              if (!ref?.classList.contains('active-dot')) {
                // This condition solved unwanted scroll to top after closing any drawer in the page
                ref?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center'
                });
              }
              ref?.classList.add('active-dot');
            } else {
              ref?.classList.remove('active-dot');
            }
          }} key={item.uid}></Box>)}
          </Box>
        </Box>
      </Box>
    </>;
};
export default TopSlider;